import { Chevron, useToggle } from '@factorialco/deprecated-design-system'
import classNames from 'classnames'

import { observer } from 'mobx-react'

import type LeaveModel from 'modules/timeoff/store/models/Leave'
import type MedicalLeaveUpdate from 'modules/timeoff/store/models/MedicalLeaveUpdate'

import UpdateItem from './Update'
import './index.styles.css'

interface Props {
  leave: LeaveModel
  updates: MedicalLeaveUpdate[]
  employeeId: number
}

const Updates = ({ leave, updates, employeeId }: Props) => {
  const isMedical = leave.leaveType?.isMedicalLeave
  const [open, toggle] = useToggle()
  const direction = open ? 'up' : 'down'

  if (!isMedical) return null
  return (
    <div className={'Medical_updates'}>
      <>
        <ul className={classNames('Medical_list', { Medical_ope: open, Medical_closed: !open })}>
          {updates.map((update) => (
            <li key={update.attributes.id} className={'Medical_item'}>
              <UpdateItem update={update} leave={leave} employeeId={employeeId} />
            </li>
          ))}
          <li className={'Medical_item'}>
            <UpdateItem leave={leave} employeeId={employeeId} />
          </li>
        </ul>
        <div className={'Medical_showMore'} onClick={toggle(!open)}>
          <div className={'Medical_showMoreContent'}>
            <Chevron type="terciary" direction={direction} />
          </div>
        </div>
      </>
    </div>
  )
}

export default observer(Updates)
